// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-by-name-section .search-by-name {\n  width: 100%;\n  max-width: 400px;\n  margin: 4rem auto;\n}\n\n@media (max-width: 991px) {\n  .search-by-name-section .form-inline .form-group {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n  .search-by-name-section .search-by-name-submit {\n    margin-top: 16px;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
